export const formatReadableDate = (
  isoString,
  options = { includeTime: false, locale: "en-IN" }
) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const dateOptions = {
    day: "2-digit",
    month: "long",
    year: "numeric",
    ...(options.includeTime && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };

  return date.toLocaleString(options.locale, dateOptions);
};

export const formatReadableDateTime = (input) => {
  if (!input) return "";

  const date =
    input instanceof Date
      ? input
      : typeof input === "number"
      ? new Date(input)
      : new Date(String(input));

  if (isNaN(date.getTime())) return "";

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const toISTDateTime = (localDateTime) => {
  if (!localDateTime) return null;

  if (localDateTime.includes("Z") || localDateTime.includes("+")) {
    return localDateTime;
  }

  return localDateTime.length === 16
    ? `${localDateTime}:00+05:30`
    : `${localDateTime}+05:30`;
};

export const fromISTDateTime = (istDateTime) => {
  if (!istDateTime) return null;

  if (istDateTime.includes("Z")) {
    return istDateTime;
  }

  if (!istDateTime.endsWith("+05:30")) {
    return istDateTime;
  }

  const withoutOffset = istDateTime.replace("+05:30", "");

  return withoutOffset.endsWith(":00")
    ? withoutOffset.slice(0, -3)
    : withoutOffset;
};

export const toIST = (utcDateTime) => {
  if (!utcDateTime) return "";

  const date = new Date(
    utcDateTime.endsWith("Z") ? utcDateTime : `${utcDateTime}Z`
  );

  const pad = (n) => String(n).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatUtcToIstDateTime = (input) => {
  if (!input) return "";

  let date;

  if (input instanceof Date) {
    date = input;
  } else if (typeof input === "number") {
    date = new Date(input);
  } else if (typeof input === "string") {
    // Force UTC if timezone info is missing
    const hasTimezone = /Z|[+-]\d{2}:\d{2}$/.test(input);
    date = new Date(hasTimezone ? input : `${input}Z`);
  } else {
    return "";
  }

  if (isNaN(date.getTime())) return "";

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const toDatetimeLocal = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);
  const pad = (n) => String(n).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

